import { RequestedStudiesFeature } from '@vivli/features/studies/feature';
import { DataRequestStatusEnum } from '@vivli/features/data-requests/infrastructure/enum';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';

export const AmrDataRequestDatasetsComponent = () => {
    const { dataRequest } = useDataRequestContext();

    return <RequestedStudiesFeature editable={dataRequest.status === DataRequestStatusEnum.Draft} />;
};
